import { PortalBalancesRow } from '@/components/portal-modules/PortalBalancesTable';
import { currencyConfigDict } from '@/config/currency';
import { BalanceSummary } from '@/types/sso';
import { getCurrency } from '@/utils/hooks/useCurrency';
import { UseLanguageReturn } from '@/utils/hooks/useLanguage';
import { CellContext, Table } from '@tanstack/react-table';
import cn from 'classnames';
import { useNumberFormatter } from 'react-aria';
import { MdArrowCircleDown, MdArrowCircleUp, MdChevronLeft } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { generalAmountCell } from './currencyHelper';

const showWeightColumnData = (value?: number) => {
    const precision = 1;

    return value === null || value === undefined ? (
        <span className="flex justify-start text-brand-red-light">N/A</span>
    ) : (
        <div
            className={cn('flex items-center font-semibold gap-1', {
                'text-brand-green-light': value > 0,
                'text-brand-red-light': value < 0
            })}>
            {`${value.toFixed(precision)}%`}
        </div>
    );
};

function getTableSubRows(table?: Table<any>) {
    if (!table) {
        return {
            hasSubrows: false,
            allExpanded: false
        };
    }

    const rows = table.getRowModel()?.rows ?? [];
    const filteredRows = table.getFilteredRowModel()?.rows ?? [];

    const hasSubrows = rows.some((row) => row.getCanExpand());

    const expandableRows = filteredRows.filter((row) => row.getCanExpand());

    const allExpanded = expandableRows.length > 0 && expandableRows.every((row) => row.getIsExpanded());

    return {
        hasSubrows,
        allExpanded
    };
}

// export const portalBalancesColumns = (params: PortalBalancesColumnsParams) => {
//     const {
//         lang,
//         formatDate,
//         baseCurrency,
//         totalInBaseCurrency,
//         isCryptoDepositWithdrawalEnabled,
//         onDeposit,
//         onWithdraw,
//         selectedBalancesDirection
//     } = params;

//     const columns = [
//         {
//             accessorKey: 'tableCurrency',
//             header: ({ table }) => {
//                 return (
//                     <div className="flex space-x-1 items-center truncate">
//                         <button
//                             onClick={(e) => {
//                                 table.toggleAllRowsExpanded();
//                                 e.stopPropagation();
//                             }}
//                             title={table.getIsAllRowsExpanded() ? 'Collapse all rows' : 'Expand all rows'}
//                             className="relative transform scale-125 left-0">
//                             <MdChevronRight
//                                 className={cn('h-3.5 w-3.5 font-bold text-green duration-200', {
//                                     ['rotate-90 ']: table.getIsAllRowsExpanded()
//                                 })}
//                                 aria-hidden
//                             />
//                         </button>

//                         <span className="truncate">{lang.lite.currency}</span>
//                     </div>
//                 );
//             },
//             cell: ({ row, getValue }: CellContext<PortalBalancesRow, any>) => {
//                 const value = getValue();
//                 const { show } = value;
//                 return (
//                     <div
//                         className="flex items-center gap-1"
//                         style={{
//                             paddingLeft: `${row.getCanExpand() ? row.depth * 1 : row.depth * 1.5}rem`
//                         }}>
//                         <div className={`flex space-x-1`}>
//                             {row.getCanExpand() && (
//                                 <button title={row.getIsExpanded() ? 'Collapse current row' : 'Expand current row'}>
//                                     <MdChevronRight
//                                         className={cn('h-3.5 w-3.5 text-green duration-200', {
//                                             ['rotate-90']: row.getIsExpanded()
//                                         })}
//                                         aria-hidden
//                                     />
//                                 </button>
//                             )}

//                             {row.depth === 0 && show}
//                             {row.depth > 0 && `VD: ${formatDate.format(new Date(row.original.currencyName || ''))}`}
//                         </div>
//                     </div>
//                 );
//             },
//             footer: () => {
//                 return (
//                     <div className={`px-2 py-1.5 text-xs lg:text-sm flex items-start`}>
//                         <span className="font-semibold">{`${lang.balances.total} ${
//                             baseCurrency ? `(${baseCurrency})` : ''
//                         } : `}</span>
//                     </div>
//                 );
//             }
//         },
//         {
//             accessorKey: 'amount',
//             header: lang.balances.balance,
//             cell: ({ row }: CellContext<PortalBalancesRow, any>) => {
//                 const amount = row.original.amount;
//                 const { show } = row.original.tableCurrency;
//                 const precision = getCurrency(show).order_decimals;

//                 const formatQty = useNumberFormatter({
//                     minimumFractionDigits: precision > 0 ? precision : 0,
//                     maximumFractionDigits: precision > 0 ? precision : 0,
//                     trailingZeroDisplay: 'stripIfInteger',
//                     roundingMode: 'halfEven'
//                 });

//                 return generalAmountCell({
//                     amount,
//                     ccy: show,
//                     formatQty,
//                     className: row.depth === 0 ? 'font-semibold' : ''
//                 });
//             },
//             footer: () => {
//                 return <div />;
//             }
//         },
//         {
//             accessorKey: 'amountInBaseCurrency',
//             header: `${lang.balances.balance} ${baseCurrency ? `(${baseCurrency})` : ''}`,
//             cell: ({ row, getValue }: CellContext<PortalBalancesRow, any>) => {
//                 const value = getValue();
//                 const { show, order_decimals } = getCurrency(baseCurrency);
//                 const precision = order_decimals - 2;

//                 const formatQty = useNumberFormatter({
//                     minimumFractionDigits: precision > 0 ? precision : 0,
//                     maximumFractionDigits: precision > 0 ? precision : 0,
//                     roundingMode: 'halfEven'
//                 });

//                 return value === null ? (
//                     <span className="flex justify-start text-brand-red-light">N/A</span>
//                 ) : (
//                     generalAmountCell({
//                         amount: value,
//                         ccy: show,
//                         formatQty,
//                         className: row.depth === 0 ? 'font-semibold' : ''
//                     })
//                 );
//             },
//             footer: () => {
//                 const { show, order_decimals } = getCurrency(baseCurrency);
//                 const precision = order_decimals - 2;

//                 const formatQty = useNumberFormatter({
//                     minimumFractionDigits: precision > 0 ? precision : 0,
//                     maximumFractionDigits: precision > 0 ? precision : 0,
//                     roundingMode: 'halfEven'
//                 });

//                 return generalAmountCell({
//                     amount: totalInBaseCurrency,
//                     ccy: show,
//                     formatQty,
//                     className: 'font-semibold'
//                 });
//             }
//         },
//         {
//             accessorKey: 'deposit-withdrawal',
//             header: lang.portal.actions,
//             cell: ({ row, getValue }: CellContext<PortalBalancesRow, any>) => {
//                 const navigate = useNavigate();
//                 const type = currencyConfigDict[row.original.tableCurrency.show]?.type;

//                 return (
//                     ((type === 'Crypto' && isCryptoDepositWithdrawalEnabled) || type !== 'Crypto') && (
//                         <div className="flex items-center gap-2">
//                             <MdArrowCircleDown
//                                 title="Deposit"
//                                 className="hover:text-brand-primary-light w-4 h-4 lg:w-5 lg:h-5"
//                                 onClick={(e) => {
//                                     e.stopPropagation();
//                                     navigate(`/portal/deposits?currency=${row.original.tableCurrency.show}`);
//                                     onDeposit?.(row.original.tableCurrency.show);
//                                 }}
//                             />
//                             <MdArrowCircleUp
//                                 title="Withdraw"
//                                 className="hover:text-brand-secondary-light w-4 h-4 lg:w-5 lg:h-5"
//                                 onClick={(e) => {
//                                     e.stopPropagation();
//                                     navigate(`/portal/withdrawals?currency=${row.original.tableCurrency.show}`);
//                                     onWithdraw?.(row.original.tableCurrency.show);
//                                 }}
//                             />
//                         </div>
//                     )
//                 );
//             },
//             footer: () => {
//                 return <div />;
//             }
//         }
//     ];

//     if (selectedBalancesDirection === 'GB') {
//         columns.splice(3, 0, {
//             accessorKey: 'weight',
//             header: () => {
//                 return <span className="flex justify-start ">{lang.portal.weight} (%)</span>;
//             },
//             cell: (info: CellContext<PortalBalancesRow, number>) => {
//                 const value = info.getValue();

//                 return showWeightColumnData(value);
//             },
//             footer: () => {
//                 return showWeightColumnData(100);
//             }
//         });
//     }

//     return columns;
// };

interface PortalBalancesColumnsParams {
    lang: UseLanguageReturn;
    formatDate: Intl.DateTimeFormat;
    baseCurrency: string;
    totalInBaseCurrency?: number;
    isCryptoDepositWithdrawalEnabled?: boolean;
    onDeposit?: (currency: string) => void;
    onWithdraw?: (currency: string) => void;
    balanceCurrentView: 'Accounts' | 'Currency';
    isSpecificAccountSelected: boolean;
    shouldShowWeights: boolean;
}

export const portalBalancesColumns = (params: PortalBalancesColumnsParams) => {
    const {
        lang,
        formatDate,
        baseCurrency,
        totalInBaseCurrency,
        isCryptoDepositWithdrawalEnabled,
        onDeposit,
        onWithdraw,
        balanceCurrentView,
        isSpecificAccountSelected,
        shouldShowWeights
    } = params;

    const isAccountBasedView = balanceCurrentView === 'Accounts';
    const firstColumnTitle = isAccountBasedView && !isSpecificAccountSelected ? 'Account' : 'Currency';

    const columns = [
        {
            accessorKey: 'label',
            header: ({ table }) => {
                const { hasSubrows, allExpanded } = getTableSubRows(table);
                return (
                    <div className="flex items-center space-x-1">
                        {hasSubrows && (
                            <button
                                onClick={() => table.toggleAllRowsExpanded()}
                                title={table.getIsAllRowsExpanded() ? 'Collapse all rows' : 'Expand all rows'}>
                                <MdChevronLeft
                                    className={cn('h-3.5 w-3.5 text-neutral-200 duration-200', {
                                        'rotate-90': allExpanded,
                                        '-rotate-90': !allExpanded
                                    })}
                                />
                            </button>
                        )}

                        <span>{firstColumnTitle}</span>
                    </div>
                );
            },

            cell: ({ row, getValue }: CellContext<PortalBalancesRow, string>) => {
                let label = getValue();

                const isValueDateRow = row.original.rowType === 'valueDate';
                const isAccountRow = row.original.rowType === 'account';
                const isCurrencyRow = row.original.rowType === 'currency';

                const isOTC = row.original.accountType === 'OTC';
                const isPortfolio = ['GB10', 'ManagedPortfolio'].includes(row.original.accountType);

                if (isValueDateRow) {
                    label = `VD: ${formatDate.format(new Date(row.original.valueDate ?? ''))}`;
                }

                return (
                    <div
                        style={{
                            paddingLeft: `${row.depth * 1.5}rem`
                        }}>
                        <div className="flex space-x-1">
                            {row.getCanExpand() ? (
                                <button title={row.getIsExpanded() ? 'Collapse current row' : 'Expand current row'}>
                                    <MdChevronLeft
                                        className={cn('h-3.5 w-3.5 text-neutral-200 duration-200', {
                                            'rotate-90': row.getIsExpanded(),
                                            '-rotate-90': !row.getIsExpanded()
                                        })}
                                    />
                                </button>
                            ) : null}

                            <div className="flex flex-col justify-center">
                                <span
                                    className={cn({
                                        'font-semibold': isAccountBasedView ? isAccountRow : isCurrencyRow,
                                        'font-medium': isAccountBasedView ? isCurrencyRow : isAccountRow,
                                        'text-neutral-400 text-sm': isValueDateRow
                                    })}>
                                    {label}
                                </span>
                                {isAccountRow && !isOTC && !isPortfolio && (
                                    <div className="text-xs text-neutral-400 rounded-full">
                                        {row.original.accountType}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            },
            footer: () => (
                <th colSpan={2} className="p-2 text-sm font-normal">
                    <span className="font-semibold">Total ({baseCurrency}) :</span>
                </th>
            )
        },
        {
            accessorKey: 'amount',
            header: lang.balances.balance,
            cell: ({ row }: CellContext<PortalBalancesRow, any>) => {
                const amount = row.original.amount;
                const displayCurrency = row.original.displayCurrency;
                const precision = getCurrency(displayCurrency).order_decimals;

                const formatQty = useNumberFormatter({
                    minimumFractionDigits: precision > 0 ? precision : 0,
                    maximumFractionDigits: precision > 0 ? precision : 0,
                    trailingZeroDisplay: 'stripIfInteger',
                    roundingMode: 'halfEven'
                });

                return generalAmountCell({
                    amount,
                    ccy: displayCurrency,
                    formatQty,
                    className: row.depth === 0 ? 'font-semibold' : ''
                });
            },
            footer: () => {
                return <div />;
            }
        },
        {
            accessorKey: 'amountInBaseCurrency',
            header: `${lang.balances.balance} ${baseCurrency ? `(${baseCurrency})` : ''}`,
            cell: ({ row, getValue }: CellContext<PortalBalancesRow, any>) => {
                const value = getValue();
                const { show, order_decimals } = getCurrency(baseCurrency);
                const precision = order_decimals - 2;

                const formatQty = useNumberFormatter({
                    minimumFractionDigits: precision > 0 ? precision : 0,
                    maximumFractionDigits: precision > 0 ? precision : 0,
                    roundingMode: 'halfEven'
                });

                return value === null ? (
                    <span className="flex justify-start text-brand-red-light">N/A</span>
                ) : (
                    generalAmountCell({
                        amount: value,
                        ccy: show,
                        formatQty,
                        className: row.depth === 0 ? 'font-semibold' : ''
                    })
                );
            },
            footer: () => {
                const { show, order_decimals } = getCurrency(baseCurrency);
                const precision = order_decimals - 2;

                const formatQty = useNumberFormatter({
                    minimumFractionDigits: precision > 0 ? precision : 0,
                    maximumFractionDigits: precision > 0 ? precision : 0,
                    roundingMode: 'halfEven'
                });

                return generalAmountCell({
                    amount: totalInBaseCurrency,
                    ccy: show,
                    formatQty,
                    className: 'font-semibold'
                });
            }
        },
        {
            accessorKey: 'deposit-withdrawal',
            header: lang.portal.actions,
            cell: ({ row, getValue }: CellContext<PortalBalancesRow, any>) => {
                const navigate = useNavigate();
                const type = currencyConfigDict[row.original.displayCurrency]?.type;

                return (
                    ((type === 'Crypto' && isCryptoDepositWithdrawalEnabled) || type !== 'Crypto') && (
                        <div className="flex items-center gap-2">
                            <MdArrowCircleDown
                                title="Deposit"
                                className="hover:text-brand-primary-light w-4 h-4 lg:w-5 lg:h-5"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`/portal/deposits?currency=${row.original.displayCurrency}`);
                                    onDeposit?.(row.original.displayCurrency);
                                }}
                            />
                            <MdArrowCircleUp
                                title="Withdraw"
                                className="hover:text-brand-secondary-light w-4 h-4 lg:w-5 lg:h-5"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`/portal/withdrawals?currency=${row.original.displayCurrency}`);
                                    onWithdraw?.(row.original.displayCurrency);
                                }}
                            />
                        </div>
                    )
                );
            },
            footer: () => {
                return <div />;
            }
        }
    ];

    if (shouldShowWeights) {
        columns.splice(3, 0, {
            accessorKey: 'weight',
            header: () => {
                return <span className="flex justify-start ">{lang.portal.weight} (%)</span>;
            },
            cell: (info: any) => {
                const value = info.getValue();
                return showWeightColumnData(value);
            },
            footer: () => {
                return showWeightColumnData(100);
            }
        } as any);
    }

    return columns;
};

export const buildAccountBasedTableRows = (rows: BalanceSummary['accountBased']): PortalBalancesRow[] => {
    return rows.map((account) => ({
        rowType: 'account',
        label: account.accountName,
        weight: account.weight,
        amount: undefined,
        amountInBaseCurrency: account?.totalAccountAmountInBaseCurrency,
        accountName: account.accountName,
        accountType: account.accountType,
        displayCurrency: '',
        subRows: account.subRows.map((currency) => ({
            rowType: 'currency',
            label: currency.currencyName,
            weight: currency.weight,
            amount: currency.totalCurrencyAmount,
            amountInBaseCurrency: currency.totalCurrencyAmountInBaseCurrency,
            displayCurrency: currency.currencyName,
            currencyName: currency.currencyName,
            accountType: account.accountType,
            subRows: currency.subRows.map((valueDate) => ({
                rowType: 'valueDate',
                weight: valueDate.weight,
                label: valueDate.valueDate,
                valueDate: valueDate.valueDate,
                amount: valueDate.currencyAmount,
                amountInBaseCurrency: valueDate.currencyAmountInBaseCurrency,
                displayCurrency: currency.currencyName,
                accountType: account.accountType
            }))
        }))
    }));
};

export const buildCurrencyBasedTableRows = (rows: BalanceSummary['currencyBased']): PortalBalancesRow[] => {
    return rows.map((currency) => ({
        rowType: 'currency',
        label: currency.currencyName,
        amount: currency.totalCurrencyAmount,
        displayCurrency: currency.currencyName,
        amountInBaseCurrency: currency.totalCurrencyAmountInBaseCurrency,
        accountType: '',
        subRows: currency.subRows.map((account) => ({
            rowType: 'account',
            label: account.accountName,
            amount: account.totalAccountAmount,
            amountInBaseCurrency: account?.totalAccountAmountInBaseCurrency,
            accountType: account.accountType,
            accountName: account.accountName,
            displayCurrency: currency.currencyName,
            subRows: account.subRows.map((valueDate) => ({
                rowType: 'valueDate',
                label: valueDate.valueDate,
                valueDate: valueDate.valueDate,
                amount: valueDate.accountAmount,
                amountInBaseCurrency: valueDate.accountAmountInBaseCurrency,
                accountType: account.accountType,
                displayCurrency: currency.currencyName
            }))
        }))
    }));
};
